/** Pending coins have been claimed, but cannot be spent until their return window ends. */
export const rewardTotal = (wallet: { available: number, pending: number }) => wallet.available + wallet.pending

export function rewardProgress(current: number | null | undefined, target: number | null | undefined) {
  return target && target > 0 ? Math.max(0, Math.min(100, ((current ?? 0) / target) * 100)) : 0
}

export function rewardTier(level?: string | null): 'silver' | 'gold' | 'platinum' | 'diamond' {
  switch (level) {
    case 'GOLD': return 'gold'
    case 'PLATINUM': return 'platinum'
    case 'DIAMOND': return 'diamond'
    default: return 'silver'
  }
}

export const isStoreRewardSource = (source?: string | null) => source === 'STORE_PURCHASE' || source === 'STORE_BONUS'

// Keep in-store redemption hidden until the shop is ready, as in the mobile app.
export const isRewardMissionVisible = (mission: { key: string }) => mission.key !== 'store_purchase'

/** Rules, rather than merchant-editable keys, identify tasks that require a native app. */
export const isMobileRewardMission = (mission: { verification: string }) => ['PUSH', 'WIDGET', 'FIRST_APP_ORDER'].includes(mission.verification)
